// extracted by mini-css-extract-plugin
export default {"container":"Proofs_container__MHkKG","form":"Proofs_form__aG0JU"};